!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.kok = t());
}(this, function () {
  "use strict";

  return [{
    locale: "kok",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "वर्स",
        relative: {
          0: "हें वर्स",
          1: "फुडलें वर्स",
          "-1": "फाटलें वर्स"
        },
        relativeTime: {
          future: {
            other: "{0} वर्सांनीं"
          },
          past: {
            other: "{0} वर्सां आदीं"
          }
        }
      },
      "year-short": {
        displayName: "वर्स",
        relative: {
          0: "हें वर्स",
          1: "फुडलें वर्स",
          "-1": "फाटलें वर्स"
        },
        relativeTime: {
          future: {
            other: "{0} वर्सांनीं"
          },
          past: {
            other: "{0} वर्स आदीं"
          }
        }
      },
      month: {
        displayName: "म्हयनो",
        relative: {
          0: "हो म्हयनो",
          1: "फुडलो म्हयनो",
          "-1": "फाटलो म्हयनो"
        },
        relativeTime: {
          future: {
            other: "{0} म्हयन्यानीं"
          },
          past: {
            other: "{0} म्हयन्यां आदीं"
          }
        }
      },
      "month-short": {
        displayName: "म्हयनो",
        relative: {
          0: "हो म्हयनो",
          1: "फुडलो म्हयनो",
          "-1": "फाटलो म्हयनो"
        },
        relativeTime: {
          future: {
            other: "{0} म्हयन्यानीं"
          },
          past: {
            other: "{0} म्हयन्यां आदीं"
          }
        }
      },
      day: {
        displayName: "दीस",
        relative: {
          0: "आयज",
          1: "फाल्यां",
          "-1": "काल"
        },
        relativeTime: {
          future: {
            other: "{0} दिसानीं"
          },
          past: {
            other: "{0} दीस आदीं"
          }
        }
      },
      "day-short": {
        displayName: "दीस",
        relative: {
          0: "आयज",
          1: "फाल्यां",
          "-1": "काल"
        },
        relativeTime: {
          future: {
            other: "{0} दिसानीं"
          },
          past: {
            other: "{0} दीस आदीं"
          }
        }
      },
      hour: {
        displayName: "वर",
        relative: {
          0: "हें वर"
        },
        relativeTime: {
          future: {
            other: "{0} वरांनीं"
          },
          past: {
            other: "{0} वरा आदीं"
          }
        }
      },
      "hour-short": {
        displayName: "वर",
        relative: {
          0: "हें वर"
        },
        relativeTime: {
          future: {
            other: "{0} वरांनीं"
          },
          past: {
            other: "{0} वरा आदीं"
          }
        }
      },
      minute: {
        displayName: "मिनीट",
        relative: {
          0: "हें मिनीट"
        },
        relativeTime: {
          future: {
            other: "{0} मिन्टां"
          },
          past: {
            other: "{0} मिन्टां आदीं"
          }
        }
      },
      "minute-short": {
        displayName: "मिनीट",
        relative: {
          0: "हें मिनीट"
        },
        relativeTime: {
          future: {
            other: "{0} मिन्टां"
          },
          past: {
            other: "{0} मिन्टां आदीं"
          }
        }
      },
      second: {
        displayName: "सेकंद",
        relative: {
          0: "आतां"
        },
        relativeTime: {
          future: {
            other: "{0} सेकंदानीं"
          },
          past: {
            other: "{0} सेकंद आदीं"
          }
        }
      },
      "second-short": {
        displayName: "सेकंद",
        relative: {
          0: "आतां"
        },
        relativeTime: {
          future: {
            other: "{0} सेकंदानीं"
          },
          past: {
            other: "{0} से. आदीं"
          }
        }
      }
    }
  }];
});